import { format, formatDistanceToNow, isValid } from "date-fns";

/**
 * The right-hand timestamp of every Activity Log row (2026-09-09, user:
 * "show the exact time and date also, each thing happened").
 *
 * Two lines, right-aligned:
 *   30 minutes ago            ← relative, the line the timeline always had
 *   9 Sep 2026 · 01:15 am     ← exact, same shape the lead card header uses
 *
 * The exact line is also the `title`, so hovering the relative line reads it
 * on narrow drawers where the second line is the one that gets clipped.
 * Renders nothing when the row carries no `createdAt`.
 */
export default function ActivityTimestamp({
  createdAt,
}: {
  createdAt?: string | number | Date | null;
}) {
  if (!createdAt) return null;
  const date = new Date(createdAt);
  if (!isValid(date)) return null;

  const relative = formatDistanceToNow(date, { addSuffix: true });
  const exact = `${format(date, "d MMM yyyy")} · ${format(date, "hh:mm a")}`;

  return (
    <div
      className="flex flex-col items-end shrink-0 ml-6 leading-tight"
      title={exact}
    >
      <p className="text-[12px] font-normal text-[#697571] tracking-[-0.24px] whitespace-nowrap">
        {relative}
      </p>
      <p className="text-[11px] font-normal text-[#9ba3a0] tracking-[-0.22px] whitespace-nowrap tabular-nums">
        {exact}
      </p>
    </div>
  );
}
